"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _confetti = _interopRequireDefault(require("./confetti.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ConfettiWrapper = _styledComponents.default.div.withConfig({
  displayName: "Confetti__ConfettiWrapper",
  componentId: "sc-1fqbzsu-0"
})(["@keyframes confetti-slow{0%{transform:translate3d(0px,0px,0px) rotateX(0) rotateY(0);}100%{transform:translate3d(25px,105vh,0) rotateX(360deg) rotateY(180deg);}}@keyframes confetti-medium{0%{transform:translate3d(0px,0px,0px) rotateX(0) rotateY(0);}100%{transform:translate3d(100px,105vh,0) rotateX(100deg) rotateY(360deg);}}@keyframes confetti-fast{0%{transform:translate3d(0px,0px,0px) rotateX(0) rotateY(0);}100%{transform:translate3d(-50px,105vh,0) rotateX(10deg) rotateY(250deg);}}.conf-container{position:fixed;z-index:1000;width:100%;}.confetti-container{}.confetti{position:fixed;z-index:1000;top:-20px;border-radius:0%;&--animation-slow{animation:confetti-slow 4.25s linear 1 forwards;}&--animation-medium{animation:confetti-medium 3.75s linear 1 forwards;}&--animation-fast{animation:confetti-fast 3.25s linear 1 forwards;}}"]);

var Confetti = function Confetti(_ref) {
  var enableConfetti = _ref.enableConfetti,
      delay = _ref.delay,
      time = _ref.time,
      customProperties = _ref.customProperties;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      el = _useState2[0],
      setEl = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      show = _useState4[0],
      setshow = _useState4[1];

  var containerEl = null;

  var setupElements = function setupElements() {
    containerEl = document.createElement('div'); // containerEl.classList.add('confetti-container');

    el.appendChild(containerEl);
  };

  _react.default.useLayoutEffect(function () {
    if (typeof window !== 'undefined') {
      setshow(true);
      setEl(document.querySelector('.airasia-rebranding-js-container'));
    }
  }, [delay, time]);

  _react.default.useEffect(function () {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var timer;

    if (el) {
      setupElements();
      var timeout = setTimeout(function () {
        timer = setInterval(function () {
          var confettiEl = document.createElement('div');
          var confettiSize = "".concat(Math.floor(Math.random() * 3) + 7, "px");

          var confettiBackground = _constant.CONFETTI_COLORS[Math.floor(Math.random() * _constant.CONFETTI_COLORS.length)];

          var confettiLeft = "".concat(Math.floor(Math.random() * el.offsetWidth), "px");

          var confettiAnimation = _constant.CONFETTI_ANIMATIONS[Math.floor(Math.random() * _constant.CONFETTI_ANIMATIONS.length)];

          confettiEl.classList.add('confetti', "confetti--animation-".concat(confettiAnimation));
          confettiEl.style.left = confettiLeft;
          confettiEl.style.width = confettiSize;
          confettiEl.style.height = confettiSize;
          confettiEl.style.backgroundColor = confettiBackground;
          confettiEl.removeTimeout = setTimeout(function () {
            confettiEl.parentNode.removeChild(confettiEl);
          }, 5000);
          containerEl.appendChild(confettiEl);
        }, 25);
        setTimeout(function () {
          clearInterval(timer);
          setshow(false);
        }, time);
        clearTimeout(timeout);
      }, delay);
    }

    return function () {
      return timer && clearInterval(timer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [el]);

  var getMain = function getMain() {
    return enableConfetti && show && /*#__PURE__*/_react.default.createElement(ConfettiWrapper, customProperties, /*#__PURE__*/_react.default.createElement("div", {
      className: "airasia-rebranding-js-container conf-container"
    }));
  };

  return getMain();
};

Confetti.propTypes = _confetti.default.PropTypes;
Confetti.defaultProps = _confetti.default.DefaultProps;
var _default = Confetti;
exports.default = _default;